import { logger } from "@/utils/logger";
import { pinia, useAuthStore } from "@/stores";
export function setupInterceptors(api) {
    api.interceptors.request.use((config) => {
        try {
            const authData = localStorage.getItem("transportation_auth");
            if (authData) {
                const sessionData = JSON.parse(authData);
                if (sessionData?.tokens?.access_token) {
                    config.headers.Authorization = `Bearer ${sessionData.tokens.access_token}`;
                }
            }
        }
        catch (error) {
            logger.warn("Auth data parse error:", error);
        }
        // FormData: varsayılan application/json ve elle multipart/form-data
        // boundary'siz gönderilirse sunucu tek parça / bozuk okur (çoklu GTFS → 1 feed).
        if (typeof FormData !== "undefined" && config.data instanceof FormData) {
            const headers = config.headers;
            if (typeof headers?.delete === "function") {
                headers.delete("Content-Type");
            }
            else if (headers) {
                delete headers["Content-Type"];
                delete headers["content-type"];
            }
        }
        return config;
    }, (error) => Promise.reject(error));
    api.interceptors.response.use((response) => response, (error) => {
        if (error.response?.status === 401) {
            useAuthStore(pinia).clearSession();
            if (window.location.pathname !== "/login") {
                window.location.href = "/login";
            }
        }
        return Promise.reject(error);
    });
}
